module.exports = __webpack_public_path__ + "202408221624/img/diom_2.d7b422e2.png";